import React from 'react';

export default function RecurringPicker({ value, onChange }) {
  // value shape: { enabled: boolean, count: number, auto_renew?: boolean }
  return (
    <div className="border rounded-xl p-3">
      <label className="flex items-center gap-2">
        <input
          type="checkbox"
          checked={!!value.enabled}
          onChange={e => onChange({ ...value, enabled: e.target.checked })}
        />
        <span className="font-medium">Repeat every week</span>
      </label>

      {value.enabled && (
        <>
          <div className="mt-3 grid grid-cols-2 gap-3">
            <div>
              <label className="block text-xs text-gray-600">Occurrences</label>
              <input
                type="number"
                min={2}
                max={24}
                value={Number(value.count ?? 4)}
                onChange={e => onChange({ ...value, count: Number(e.target.value || 2) })}
                className="border rounded px-2 py-1 w-full"
              />
            </div>
          </div>

          <label className="mt-3 flex items-center gap-2">
            <input
              type="checkbox"
              checked={!!value.auto_renew}
              onChange={e => onChange({ ...value, auto_renew: e.target.checked })}
            />
            <span className="text-sm">Auto-renew</span>
          </label>
        </>
      )}
    </div>
  );
}
